import React, { useState, useEffect, useRef, type ReactNode } from "react";
import { AuthContext } from "./AuthContext";
import api from "../../../api/api";
import Cookies from "js-cookie";

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const hasRun = useRef(false); // strict mode cutoff

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const checkAuth = async () => {
      const refreshToken = Cookies.get("refresh_token");
      if (!refreshToken) {
        setIsAuthChecked(true);
        return;
      }

      try {
        await api.refresh({ refresh_token: refreshToken });
        setIsLoggedIn(true);
      } catch (error) {
        console.error("Auth check failed:", error);
        setIsLoggedIn(false);
      } finally {
        setIsAuthChecked(true);
      }
    };

    checkAuth();
  }, []);

  if (!isAuthChecked) return null;

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};
